export default __webpack_public_path__ + "static/media/shaimaa.6eb2d93d.jpg";